import { JsonObject } from 'ta-json';
import { GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_discountedPriceAppearance } from '@src/app/generated/GetAllRetailers';
import { DiscountedPriceAppearanceInput } from '@src/app/generated/globalTypes';
import { DiscountedPriceAppearance } from '@ess/jg-rule-executor/dist/src/domain/discounted-price-appearance';

/**
 * PriceAppearance
 */
@JsonObject()
export class PortalDiscountedPriceAppearance extends DiscountedPriceAppearance {
  static fromGql(
    gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_discountedPriceAppearance
  ): PortalDiscountedPriceAppearance {
    return new PortalDiscountedPriceAppearance(
      gql.strikeThrough,
      gql.textSize,
      gql.color
    );
  }

  toGqlInput(): DiscountedPriceAppearanceInput {
    return {
      strikeThrough: this.strikeThrough,
      textSize: this.textSize,
      color: this.color,
    };
  }
}
